import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useAuth } from '@providers/authProvider';
import { themeColors } from '@theme/classNames';

/** Gates only pages marked requiresBricklink in the shared route registry. */
function BricklinkRoute({ pageLabel, children }) {
    const { user } = useAuth();
    if (typeof pageLabel !== 'string' || pageLabel.length === 0) {
        throw new Error('BricklinkRoute requires a page label');
    }
    if (!user) return null;
    if (typeof user.bricklink_connected !== 'boolean') {
        throw new Error('BricklinkRoute: bricklink_connected must be a boolean');
    }
    if (user.bricklink_connected) return children;
    return (
        <section className={`p-6 ${themeColors.text.primary}`}>
            <h1 className="text-2xl font-semibold mb-4">{pageLabel}</h1>
            <p>{`Connect BrickLink to use ${pageLabel}.`}</p>
            <Link to="/app/settings" className="text-primary underline">Connect BrickLink in Settings</Link>
        </section>
    );
}

BricklinkRoute.propTypes = {
    pageLabel: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export default BricklinkRoute;
